import { runAction } from "../client";
import {
    DashboardFn, DashboardResult,
    TakeOverSensorExcessFn, IncidentAssignment, DashboardRequest, AssignemtnResult
} from "./interfaces";

export const getDashboard: DashboardFn = (request: DashboardRequest) => {
    return runAction<DashboardResult>('/action/GetDashboard', request);
};

export const takeOverSensorExcess: TakeOverSensorExcessFn = (assignment: IncidentAssignment) => {
    return runAction<AssignemtnResult>('/action/TakeOverSensorExcess', assignment);
};


// WEBPACK FOOTER //
// ./src/rest/Dashboard/index.ts